import * as palette from "../palette";

import PropTypes from "prop-types";
import React from "react";

export default function Mention({ offsetKey, children }) {
  return (
    <div
      data-offset-key={offsetKey}
      css={{
        fontSize: 14,
        borderRadius: 2,
        backgroundColor: palette.lightestBlue,
        color: palette.primary,
        display: "inline-flex",
      }}
    >
      {children}
    </div>
  );
}

Mention.propTypes = {
  offsetKey: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};
